import { Menu } from "@headlessui/react";
import { mdiFileDocumentOutline, mdiHelpCircleOutline, mdiInformationOutline, mdiPuzzle, } from "@mdi/js";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setDialogVisible } from "../../../actions/session";
import { useExtensionContext } from "../../../ExtensionProvider";
import { Dropdown } from "../../../ui/components/dropdown/Dropdown";
import { DropdownDivider } from "../../../ui/components/dropdown/DropdownDivider";
import { DropdownItem } from "../../../ui/components/dropdown/DropdownItem";
import { DropdownItems } from "../../../ui/components/dropdown/DropdownItems";
import { IconButton } from "./IconButton";
import { useGlobalIconActions } from "./useGlobalIconActions";
export const HelpSection = () => {
    const dispatch = useDispatch();
    const extensions = useExtensionContext();
    const api = extensions.getApi();
    const { t } = useTranslation();
    const handleHelpCentre = useCallback(() => {
        api.events.emit("open-knowledge-base");
    }, [api]);
    const handleDiagnosticFiles = useCallback(() => {
        dispatch(setDialogVisible("diagnostics-files-dialog"));
    }, [dispatch]);
    const handleAbout = useCallback(() => {
        api.events.emit("show-main-page", "About");
    }, [api]);
    const globalIconActions = useGlobalIconActions(extensions);
    const handleGlobalIconAction = useCallback((action) => {
        return () => {
            if (action.action) {
                action.action([]);
            }
        };
    }, []);
    return (React.createElement(Dropdown, null,
        React.createElement(Menu.Button, { as: IconButton, iconPath: mdiHelpCircleOutline, title: t("Help") }),
        React.createElement(DropdownItems, null,
            globalIconActions.map((action) => (React.createElement(DropdownItem, { key: `${action.icon}-${action.title}`, leftIconPath: mdiPuzzle, onClick: handleGlobalIconAction(action) }, t(action.title, { ns: action.options?.namespace })))),
            globalIconActions.length > 0 && React.createElement(DropdownDivider, null),
            React.createElement(DropdownItem, { leftIconPath: mdiHelpCircleOutline, onClick: handleHelpCentre }, t("Help centre")),
            React.createElement(DropdownItem, { leftIconPath: mdiFileDocumentOutline, onClick: handleDiagnosticFiles }, t("View logs")),
            React.createElement(DropdownItem, { leftIconPath: mdiInformationOutline, onClick: handleAbout }, t("About")))));
};
